import { ssmRouterGuardService } from "@/shared/services/router-guard-service";
import Vue from "vue";
import Router from "vue-router";
import { RouterNames } from "./routernames";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/main",
    },
    {
      path: "*",
      redirect: "/main",
    },
    {
      path: "/login",
      name: RouterNames.Login,
      component: () => import("@/views/login/login-formulario.vue"),
    },
    {
      path: "/lostpwd",
      name: RouterNames.lostpwd,
      component: () => import("@/views/lostpwdforms/pswlost.vue"),
    },
    {
      path: "/confirm-new-password/:token",
      name: RouterNames.confirm_new_password,
      component: () => import("@/views/lostpwdforms/pwdlost-confirm.vue"),
    },
    {
      path: "/instalacion",
      name: RouterNames.instalacion,
      component: () => import("@/views/instalacion/instalacion.vue"),
    },
    {
      path: "/mainlayout",
      name: RouterNames.main,
      component: () => import("@/components/titulopantalla/titulo.vue"),
      children: [
        {
          path: "otp",
          name: RouterNames.otp,
          component: () =>
            import("@/views/layout/main-layout-base.vue"),
          children: [
            {
              path: "/iniciar-otp",
              name: RouterNames.configurarotp,
              component: () => import("@/views/Otp/AuthOtp.vue"),
            },
            {
              path: "/logear-otp",
              name: RouterNames.logearotp,
              component: () => import("@/views/Otp/LogearOtp.vue"),
            },

          ],
        },
      ],
    },
    {
      path: "/fichaje",
      name: RouterNames.fichaje,
      component: () =>
        import("@/views/mainlayout_sinlogin/main-layout-sin-login.vue"),
      children: [
        {
          path: "form",
          name: RouterNames.fichajeform,
          component: () =>
            import("@/views/Fichaje/FichajeAutomaticoFormulario.vue"),
        },
      ],
    },
    {
      path: "/main",
      redirect: "/main/home",
      name: RouterNames.mainlayout,
      component: () => import("@/views/mainlayout/main-layout.vue"),
      beforeEnter: ssmRouterGuardService.beforeEnter,
      children: [
        {
          path: "home",
          name: RouterNames.Home,
          component: () => import("@/views/home/home.vue"),
        },
        {
          path: "tablas",
          name: RouterNames.tablas_test,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "tabla/:id",
              name: RouterNames.table,
              component: () =>
                import("@/views/dynamic_tables/full_dynamic_table.vue"),
            },
            {
              path: "dxtabla/:id",
              name: RouterNames.dxtable,
              component: () =>
                import("@/components/DataTableGenerico/DxFullDataTable.vue"),
            },
          ],
        },
        {
          path: "tbkn",
          name: RouterNames.tbkn,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "tbkn/:id",
              name: RouterNames.viewtbkn,
              component: () =>
                import("@/views/dynamic_views/dynamic_change_views.vue"),
            },
          ],
        },
        {
          path: "kanban",
          name: RouterNames.kanban,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "kanban/:id",
              name: RouterNames.viewKanban,
              component: () => import("@/views/dynamickanban/ViewKanban.vue"),
            },
          ],
        },
        {
          path: "enumeraciones",
          name: RouterNames.enumeraciones,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "enumeracion/:id_cabezera",
              name: RouterNames.enumeracion,
              component: () =>
                import("@/views/prioridades/GenericPrioridadesForm.vue"),
            },
          ],
        },
        {
          path: "informes",
          name: RouterNames.informes,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "informe1",
              name: RouterNames.informe1,
              component: () => import("@/views/Informes/InformesPorFecha.vue"),
              children: [],
            },

            {
              path: "informe2",
              name: RouterNames.informe2,
              component: () =>
                import("@/views/Informes/InformePorEmpleado.vue"),
            },
            {
              path: "informe3",
              name: RouterNames.informe3,
              component: () =>
                import("@/views/Informes/InformePorCentroTrabajo.vue"),
            },
          ],
        },
        {
          path: "administracion",
          name: RouterNames.administracion,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "usuarios",
              name: RouterNames.usuarios,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.usuarioslista,
                  component: () => import("@/views/usuarios/UsuariosLista.vue"),
                  children: [],
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.usuariosformulario,
                  component: () =>
                    import("@/views/usuarios/UsuariosFormulario.vue"),
                  children: [],
                },
                {
                  path: "contratos_empleado/:id/:id_empleado",
                  name: RouterNames.contratos_empleado,
                  component: () =>
                    import(
                      "@/views/hist_contratos_empleado/hist_contratos_empleadoFormulario.vue"
                    ),
                  children: [],
                },
                {
                  path: "fichajes/:id",
                  name: RouterNames.usuariosfichajes,
                  component: () =>
                    import("@/views/usuarios/UsuariosFichajes.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "rol",
              name: RouterNames.rol,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.rollista,
                  component: () => import("@/views/roles/RolesLista.vue"),
                  children: [],
                },
                {
                  path: "formulario",
                  name: RouterNames.rolformulario,
                  component: () => import("@/views/roles/RolesFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "calendario",
              name: RouterNames.calendario,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "calendario",
                  name: RouterNames.calendariolaboral,
                  component: () =>
                    import("@/views/Calendarios/CalendarioLaboral.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "notificaciones/formulario",
              name: RouterNames.notificaciones,
              component: () =>
                import("@/views/notificaciones/NotificacionesForm.vue"),
            },
            {
              path: "centros_de_trabajo",
              name: RouterNames.centros_de_trabajo,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "centros_de_trabajo/:id",
                  name: RouterNames.centros_de_trabajoformulario,
                  component: () =>
                    import(
                      "@/views/centro_trabajo/centro_trabajoFormulario.vue"
                    ),
                  children: [],
                },
              ],
            },
            {
              path: "tipos_fichaje",
              name: RouterNames.tipos_fichaje,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "tipos_fichaje/:id",
                  name: RouterNames.TiposFichajeFormulario,
                  component: () =>
                    import(
                      "@/views/TiposFichajeFormulario/TiposFichajeFormulario.vue"
                    ),
                  children: [],
                },
              ],
            },
            {
              path: "fichajes",
              name: RouterNames.fichajes,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "ficha_fichaje/:id",
                  name: RouterNames.FichaFichajeFormulario,
                  component: () =>
                    import("@/views/Fichaje/FichajeFormulario.vue"),
                  children: [],
                },

                {
                  path: "lista",
                  name: RouterNames.listafichajes,
                  component: () => import("@/views/Fichaje/FichajesTabla.vue"),
                },{
                  path: "edicion_masiva_fichajes",
                  name: RouterNames.edicion_masiva_fichajes,
                  component: () => import("@/views/Fichaje/EdicionMasivaFichajes.vue"),
                },
                {
                  path: "gps",
                  name: RouterNames.fichajes_gps,
                  component: () => import("@/views/Fichaje/GpsFichajes.vue"),
                  children: [],
                }, {
                  path: "calendario_fichajes",
                  name: RouterNames.calendario_fichajes,
                  component: () => import("@/views/Fichaje/FichajesRH.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "tipos_contrato",
              name: RouterNames.tipos_contrato,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "tipos_contrato/:id",
                  name: RouterNames.tipos_contratoFormulario,
                  component: () =>
                    import(
                      "@/views/Tipos_contrato/Tipos_contratoFormulario.vue"
                    ),
                  children: [],
                },
              ],
            },
            {
              path: "convenios",
              name: RouterNames.convenios,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "convenios/:id",
                  name: RouterNames.conveniosformulario,
                  component: () =>
                    import("@/views/Convenios/ConveniosFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "datos_empresa",
              name: RouterNames.datos_empresa,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "datos_empresa/:id",
                  name: RouterNames.datos_empresaformulario,
                  component: () =>
                    import(
                      "@/views/Administrador/AdminDatosEmpresaFormulario.vue"
                    ),
                  children: [],
                },
                {
                  path: "empresa/:id",
                  name: RouterNames.datos_empresaformulario_empresa,
                  component: () =>
                    import("@/views/Datos_empresas/DatosEmpresaFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "admin",
              name: RouterNames.admin,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "usuarios_plataforma_admin/:id",
                  name: RouterNames.usuarios_plataforma_admin,
                  component: () =>
                    import("@/views/Administrador/AdminUsuariosFormulario.vue"),
                  children: [],
                },
              ],
            },
          ],
        },
        {
          path: "plataforma",
          name: RouterNames.plataforma,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "instalacion/formulario",
              name: RouterNames.instalacion_plataforma,
              component: () => import("@/views/instalacion/instalacion.vue"),
            },
            {
              path: "menu",
              name: RouterNames.menu_plataforma,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.menu_plataforma_lista,
                  component: () =>
                    import("@/views/plataforma/menu/MenuLista.vue"),
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.menu_plataforma_formulario,
                  component: () =>
                    import("@/views/plataforma/menu/MenuFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "clientes",
              name: RouterNames.clientes,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.clientesformulario,
                  component: () =>
                    import("@/views/Clientes/clienteFormulario.vue"),
                  children: [],
                },
              ],
            },{
              path: "permisos",
              name: RouterNames.permisos,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "permisoslista",
                  name: RouterNames.permisoslista,
                  component: () =>
                    import("@/views/tables/table_editing.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "logs",
              name: RouterNames.logs,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.logsformulario,
                  component: () =>
                    import("@/views/plataforma/logs/logs_formulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "tablas",
              name: RouterNames.tablas,
              component: () =>
                import("@/components/titulopantalla/titulo-reactivo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.tablaslista,
                  component: () =>
                    import(
                      "@/views/dynamic_tables/views_settings/dynamic_tables_lista.vue"
                    ),
                  children: [],
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.tablasformulario,
                  component: () =>
                    import(
                      "@/views/dynamic_tables/views_settings/dynamic_tables_formulario.vue"
                    ),
                  children: [],
                },
              ],
            },
          ],
        },
        {
          path: "mi_perfil",
          name: RouterNames.mi_perfil,
          component: () => import("@/views/usuarios/MiPerfil.vue"),
        },
        {
          path: "cerrar_session",
          name: RouterNames.cerrar_session,
          component: () => import("@/views/cerrar_session.vue"),
          children: [],
        },
      ],
    },
  ],
});
